import React from 'react';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    chip: {
        //margin: theme.spacing(1),
        color: '#fff',
        '&:hover': {
            opacity: 0.8,
        },
    },
    active: {
        backgroundColor: '#ddfbdd',
        color: '#2b9400'
    },
    deactive: {
        backgroundColor: '#f9dede',
        color: '#be0202'
    },
    other:{
         backgroundColor: '#fafce2',
        color: '#f4a707'
    }
}));

const CustomChip = ({ label, onClick }) => {
    const classes = useStyles();

    // Determine the class based on the label
    const chipClass = label?.toUpperCase() == 'ACTIVE' ? "bg-light-green text-green" :(label?.toUpperCase() == 'DEACTIVE' ? "bg-light-error text-error":classes.other);
    return (
        <Chip
            clickable
            label={label}
            onClick={onClick}
            className={`${classes.chip} ${chipClass}`}
            size="small"
        //variant="outlined"
        />
    );
};

export default CustomChip;
